import React from "react"
import { styled } from "@mui/material/styles"
import { withRouter } from "react-router"
import ImageButton from "atoms/button/ImageButton"
import LogoutIcon from "assets/images/BusinessDLogout.png"
import { DLogout } from "apis/DLogout"

const StyledImg = styled("img")({
  width: "170px",
})

const DLogoutButton = (props) => {
  return (
    <ImageButton
      disableRipple
      id="dLogoutButton"
      onClick={() => {
        DLogout()
      }}
    >
      <StyledImg src={LogoutIcon} alt="d ログアウト" />
    </ImageButton>
  )
}

export default withRouter(DLogoutButton)
